import Grid from '@mui/material/Grid2';
import { Box } from '@mui/material';
import { PAGE_CONTENT_HEIGHT } from '../const/config';
import HeaderSub from './header_sub';

const PageLayout = ({ pageTitle = "", riskStatus, showRiskStatus, dateTime, children }) => (
    <Box
        sx={{
            height: { xs: '100%', sm: PAGE_CONTENT_HEIGHT },
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column'
        }}
    >
        <HeaderSub
            pageTitle={pageTitle}
            riskStatus={riskStatus}
            showRiskStatus={showRiskStatus}
            dateTime={dateTime}
        />
        <Grid
            container
            spacing={0}
            columns={12}
            sx={{
                height: { xs: 'auto', sm: '100%' },
                width: '100%',
                padding: 0,
                m: 0,
                flexGrow: 1
            }}
        >
            {children}
        </Grid>
    </Box>
);

export default PageLayout;